<template lang="pug">
  el-form( ref="aptSearchForm" size='mini' class='aptSearchForm' label-width='7em')
    el-tabs(  )
      el-tab-pane( label="Basic Search")
        el-form-item( label="Bedrooms" )
          el-select( v-model="beds" multiple placeholder="Any Number of Bedrooms" )
            el-option(
                v-for="item in bedOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            )
        el-form-item( label="Min Rent" min='0' )
          el-input-number( v-model="minRent" :step="100" placeholder="No Min" )
        el-form-item( label="Max Rent" prop="maxRent" min='0')
          el-input-number( v-model="maxRent" :step="100" placeholder="No Max")
        el-form-item( label="Move-In" prop="availFrom")
          el-date-picker( clearable v-model="availFrom" type="date" placeholder="No Earliest Date" format="MMM d" :picker-options="dateOptions" )
        el-form-item( label="to" prop="availTo" )
          el-date-picker( clearable v-model="availTo" type="date" placeholder="No Latest Date" format="MMM d" :picker-options="dateOptions" )
        el-form-item( label="Pets" prop="pets" )
          el-checkbox-group( v-model="pets" )
            el-checkbox-button( label="cat" ) Cat
            el-checkbox-button( label="dog" ) Dog
        el-form-item( label="Where" prop="locations" )
          el-select( v-model="locations" multiple filterable reserve-keyword placeholder="Everywhere")
            el-option-group(label="Most Common Choices")
              el-option(key="Boston:Allston" label="Boston - Allston" value="Boston:Allston")
              el-option(key="Boston:Brighton" label="Boston - Brighton" value="Boston:Brighton")
              el-option(key="Boston:Jamaica Plain" label="Boston - Jamaica Plain" value="Boston:Jamaica Plain")
            el-option-group(
              v-for="city in neighborhoods"
              :key="city.Name[0]"
              :label="city.Name[0]"
            )
              el-option(
                v-for="neighborhood in city.Neighborhood"
                :key="city.Name[0] + ':' + neighborhood"
                :label="neighborhood"
                :value="city.Name[0] + ':' + neighborhood"
              )
    
      el-tab-pane( label="More Options")
        el-form-item( label="Bathrooms")
            el-select( v-model="baths" multiple placeholder="Any Number of Bathrooms")
              el-option(
                  v-for="item in bathOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              )
        //- el-form-item( label='No Fee Only' prop="noFee")
        //-   el-switch( v-model="noFee" )
        //- el-form-item( label='Photos Only' prop="photosOnly")
        //-   el-switch( v-model="photosOnly" )
        //baths, photo, street_name, POI maybe,
        el-form-item( label="Street Name")
          el-input( v-model='streetName' placeholder="Any Street" clearable)
        el-form-item( label='Listing IDs')
          el-input( v-model='listingIDs' placeholder="Separate multiple with commas" clearable )
</template>

<script>
import {getNeighborhoods, getMonthShortcuts} from "../api/listings.js"
  
export default {
  data() {
    // const validateMaxRent = (rule, value, callback) => {
    //   (value < this.minRent) 
    //     ? callback(new Error())
    //     : callback();
    // }
    return {
      // rules: {
      //   beds: [
      //     { required: true, message: 'Select at least one.', trigger: 'change', type: 'array' }
      //   ],
      //   maxRent: [
      //     { min:0, message: 'Can\'t be negative.', type:'integer', trigger: 'change'},
      //     { validator:validateMaxRent, message:'Lower than min.', trigger: 'change'}
      //   ]
      // },
      bedOptions: [
        { value: 'studio', label: 'Studio' },
        { value: '1', label: '1' },
        { value: '1.5,1.8', label: '1|2 Split' },
        { value: '2', label: '2' },
        { value: '2.5,2.8', label: '2|3 Split' },
        { value: '3', label: '3' },
        { value: '3.5,3.8', label: '3|4 Split' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' }
      ],
      bathOptions: [
        { value: '1', label: '1' },
        { value: '1.5', label: '1.5' },
        { value: '2', label: '2' },
        { value: '2.5', label: '2.5' },
        { value: '3', label: '3' },
        { value: '3.5', label: '3.5' },
        { value: '4', label: '4' }
      ],
      dateOptions: {
        shortcuts: this.getMonthShortcuts()
      },
      neighborhoods: null
    }
  },
  computed: {
    maxRent: {
      get(){ return this.$store.state.maxRent },
      set(value){ this.$store.commit('updateMaxRent', value) }
    },

    minRent: {
      get(){ return this.$store.state.minRent },
      set(value){ this.$store.commit('updateMinRent', value) }
    },

    beds: {
      get(){ return this.$store.state.beds },
      set(value){ this.$store.commit('updateBeds', value) }
    },

    baths: {
      get(){ return this.$store.state.baths },
      set(value){ this.$store.commit('updateBaths', value) }
    },

    availFrom: {
      get(){ return this.$store.state.availFrom },
      set(value){ this.$store.commit('updateAvailFrom', value) }
    },

    availTo: {
      get(){ return this.$store.state.availTo },
      set(value){ this.$store.commit('updateAvailTo', value) }
    },

    pets: {
      get(){ return this.$store.state.pets },
      set(value){ this.$store.commit('updatePets', value) }
    },

    locations: {
      get(){ return this.$store.state.locations },
      set(value){ this.$store.commit('updateLocations', value) }
    },

    noFee: {
      get(){ return this.$store.state.noFee },
      set(value){ this.$store.commit('updateNoFee', value) }
    },

    photosOnly: {
      get(){ return this.$store.state.photosOnly },
      set(value){ this.$store.commit('updatePhotosOnly', value) }
    },

    streetName: {
      get(){ return this.$store.state.streetName },
      set(value){ this.$store.commit('updateStreetName', value) }
    },

    listingIDs: {
      get(){ return this.$store.state.listingIDs },
      set(value){ this.$store.commit('updateListingIDs', value) }
    }
  },
  methods: {
    //updateForm(){
      //this.$refs.searchParameters.validate((valid) => {
      //  (valid) 
      //    ? this.$emit('apt_form_updated', this.searchParameters)
      //    : this.$emit('apt_form_updated', null)
      //});
    //},
    //reset(){
    //  this.$refs.searchParameters.resetFields();
    //  this.$emit('apt_form_updated', null);
    //},
    
    getNeighborhoods(){
      getNeighborhoods()
      .then(neighborhoods => {
        this.neighborhoods = neighborhoods;
      })
      .catch(error => {
        this.console.log("Unable to access neighborhood data for search form: " + error);
      });
    },
    getMonthShortcuts(){
      return getMonthShortcuts();
    }
  },
  mounted(){
    this.getNeighborhoods();
  }
}
</script>

<style scoped>
.aptSearchForm{
  text-align: left;
}
.el-tabs{
  width: 320px;
}
.el-form-item__label{
  font-weight: 900;
}

</style>